import React, { useEffect, useRef, useState } from 'react';
import Header from '../../components/header';
import Layout from '../../components/layout';
import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import Icon from '../../components/icons';
import Drawer from '../../components/Drawer';
import CreateFacilities from './_components/createFacilities';
import SubFacilities from './_components/subFacilities';
import { Dropdown, Menu } from '../../components/Dropdown';
import Button from '../../components/elements/button';
import barnhouseImg from '../../images/barn_house_icon.png';
import { useFacilitiesApi } from '../../store/api/hooks/facilitiesApiHook';
import toast from 'react-hot-toast';
import CreateSubFacilitiesModal from './_components/createSubFacilities.modal';
import { useDialog } from '../../store/api/hooks/dialogHook';
import moment from 'moment';
import { DATE_FORMAT, PAGE_SIZE } from '../../_common/constant';
import Pagination from '../../components/pagination';
import Search from '../../components/search';
import { downloadExcel, downloadPDF } from '../../_common/functions';
import Loader from '../../components/loader';
import Filters from '../../components/filters';
import { filterConfigType, Option } from '../../_config/types';
import { useAllCitySelector, useAllCountySelector, useElectricityProvidersSelector, useFacilityManagersSelector, useGasProvidersSelector, useServiceTechsSelector, useStatesSelector, useTeamsSelector, useTelephoneProvidersSelector, useWaterProvidersSelector } from '../../store/selectors/masterSelector';
import { useCommonApi } from '../../store/api/hooks/commonApiHook';
import { titleCell } from '../../components/elements/function';
ModuleRegistry.registerModules([AllCommunityModule]);

const Facilities: React.FC = () => {
    const createDrawerRef: any = useRef();
    const createSubFacilityModalRef: any = useRef();
    const subFacilitiesDrawerRef: any = useRef();
    const facilityApi: any = useFacilitiesApi();
    const commonApi: any = useCommonApi();

    const { confirm } = useDialog();

    const [currentPage, setCurrentPage] = useState<number>(1);
    
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);

    const [rowData, setrowData] = useState<any>(null)
    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [subFacilities, setSubFacilities] = useState<any>(null);
    const [subFacilityFor, setSubFacilityFor] = useState<any>(null);
    const [editData, setEditData] = useState<any>(null);

    const states:Option[] | null = useStatesSelector();
    const allCounty:Option[] | null = useAllCountySelector();
    const allCity:Option[] | null = useAllCitySelector();
    const users  = useFacilityManagersSelector();
    const teams = useTeamsSelector();
    const servicetech = useServiceTechsSelector();
    const electricity = useElectricityProvidersSelector();
    const gas = useGasProvidersSelector();
    const water = useWaterProvidersSelector();
    const telephone = useTelephoneProvidersSelector();

    useEffect(() => {
        if (states == null) {
            commonApi.GetStateList({}, (resp: any) => { }, (error: any) => { });
        }
    }, [states])
    useEffect(() => {
        if (allCounty == null) {
            commonApi.GetCountyList({}, (resp: any) => { }, (error: any) => { });
        }
    }, [allCounty])
    useEffect(() => {
        if (allCity == null) {
            commonApi.GetCityList({}, (resp: any) => { }, (error: any) => { });
        }
    }, [allCity])

    useEffect(() => {
        if (users == null) {
            commonApi.GetUserList({
                pageNo: 1,
                pageSize: 1000
            }, (resp: any) => { }, (error: any) => { })
        }
    }, [users])

    useEffect(() => {
        if (teams == null) {
            commonApi.GetteamList({
                pageNo: 1,
                pageSize: 1000
            }, (resp: any) => { }, (error: any) => { })
        }
    }, [teams])

    useEffect(() => {
        if (servicetech == null) {
            commonApi.GetServicetectList({
                pageNo: 1,
                pageSize: 1000
            }, (resp: any) => { }, (error: any) => { });
        }
    }, [servicetech])

    useEffect(() => {
        if (electricity == null) {
            commonApi.GetServiceprovidertList({ ServieTypeID: 1 }, (resp: any) => { }, (error: any) => { });
        }
    }, [electricity])

    useEffect(() => {
        if (gas == null) {
            commonApi.GetServiceprovidertList({ ServieTypeID: 2 }, (resp: any) => { }, (error: any) => { });
        }
    }, [gas])

    useEffect(() => {
        if (water == null) {
            commonApi.GetServiceprovidertList({ ServieTypeID: 3 }, (resp: any) => { }, (error: any) => { });
        }
    }, [water])

    useEffect(() => {
        if (telephone == null) {
            commonApi.GetServiceprovidertList({ ServieTypeID: 4 }, (resp: any) => { }, (error: any) => { });
        }
    }, [telephone])

    const [processingoption, setProcessingoption] = useState<any>(null);

    const filtersRef: any = useRef();
    const [filters, setFilters] = useState<any>({});
    const filterConfig:filterConfigType[] = [
        {name:'Processing Facility', type:'dropdown',  key:'processingFacilityIDs', options:processingoption?processingoption:[]},
        {name:'County', type:'dropdown', key:'countyIDs', options:allCounty?allCounty:[]},
        {name:'State', type:'dropdown', key:'stateIDs', options:states?states:[]},
        {name:'City', type:'dropdown', key:'cityIDs', options:allCity?allCity:[]},
        {name:'Area', type:'text', key:'areas'},
        {name:'No of Ranches', type:'text', key:'noOfRanches'},
        {name:'Facility Manager', type:'dropdown', key:'facilityManagerIDs', options:users?users:[]},
        {name:'Service Tech', type:'dropdown', key:'serviceTechIDs', options:servicetech?servicetech:[]},
        {name:'Teams', type:'dropdown', key:'teamIDs', options:teams?teams:[]},
        {name:'Electricity Provider', type:'dropdown', key:'electricityProviderIDs', options:electricity?electricity:[]},
        {name:'Nat Gas Provider', type:'dropdown', key:'natGasProviderIDs', options:gas?gas:[]},
        {name:'Water Authority', type:'dropdown', key:'waterAuthorityIDs', options:water?water:[]},
        {name:'ISP / Telephone Provider', type:'dropdown', key:'ispTelephoneProviderIDs', options:telephone?telephone:[]},
    ]
    

    const getProcessingFacilityList = () => {
        const payload = {};
        facilityApi.getProcessingFacilityList(payload, (resp: any) => {
            let processingdiop: any = [];
            resp.processingFacilityShortList.map((facilist: any) => {
                processingdiop.push({
                    label: facilist.processingFacilityName,
                    value: facilist.processingFacilityID,
                })

                setProcessingoption(processingdiop);

            });


        }, (error: any) => {
            toast.error(error);
        });
    };



    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, width: 50, headerClass: 'bg-[#f0f0f0]' },
        { headerName: 'Facility Name', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer:titleCell },
        {
            headerName: '', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', width: 50,
            cellRenderer: (data: any) => { 
                return (
                    <div className='flex items-center justify-center h-full'>
                        <img title="Sub Facility" src={barnhouseImg} className='w-[1.875rem] cursor-pointer' onClick={() => {
                            setSubFacilities(data.data);
                            subFacilitiesDrawerRef.current.open();
                        }} alt='Sub Facility'/>
                    </div>
                )
            }
        },
        { headerName: 'Processing Facility',  field: 'processingFacilityName', headerClass: 'bg-[#f0f0f0]' , width: 250,cellRenderer:titleCell},
        { headerName: 'County', field: 'countyName', headerClass: 'bg-[#f0f0f0]', width: 140,cellRenderer:titleCell },
        { headerName: 'Address', field: 'addressLine1', headerClass: 'bg-[#f0f0f0]' ,flex:1, minWidth: 281,cellRenderer:titleCell}, 
        {
            headerName: 'Last Inspection Date', field: '', headerClass: 'bg-[#f0f0f0]', width: 180,
            cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer'>{/* {data.value ? moment(data.value).format(DATE_FORMAT) : '-'} */} - </p>
                )
            }
        },
        { headerName: 'No. of Barns', field: 'noOfRanches', headerClass: 'bg-[#f0f0f0]', width: 120, cellStyle: { textAlign: 'center' } ,cellRenderer:titleCell},
        { headerName: 'Area', field: 'area', headerClass: 'bg-[#f0f0f0]',  width:120, cellRenderer: (data: any) => <p>{data.value} sqft</p> },
        { headerName: 'Facility Manager', field: 'facilityManagers', headerClass: 'bg-[#f0f0f0]' , width: 160,   cellRenderer:titleCell},
        {
            headerName: 'Action',
            field: 'action',
            headerClass: 'bg-[#f0f0f0] text-center',
            width: 90,
            cellRenderer: (params: any) => {
                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const dropdown: any = document.querySelector('.action-dropdown');
                            if (dropdown) {
                                dropdown.focus();
                            }
                            return false;
                        }} />
                        <select
                            onChange={(e) => {
                                handleActionChange(e, params);
                                e.target.selectedIndex = -1;
                            }}
                            onFocus={(e) => {
                                e.target.selectedIndex = -1;
                            }
                            }
                            className="action-dropdown"
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                            }}
                        >
                            <option value="edit">Edit</option>
                            <option value="delete">Delete</option>
                            <option value="duplicate">Duplicate</option>
                            <option value="qr">Print QR Code</option>
                            <option value="add-sub">Add Sub Facility</option>
                        </select>
                    </div>
                )
            }
        },
    ];

    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;
        switch (action) {
            case "edit":
                // Implement edit action
                setEditData(rowData);
                createDrawerRef.current.open();
                console.log("Edit action for row: ", rowData);
                break;
            case "delete":
                // Implement delete action
                confirm({
                    type: 'delete',
                    title: 'Delete Facility',
                    message: 'Are you sure you want to delete this facility?',
                    onConfirm: () => {
                        const payload = { facilityID: rowData.facilityID };
                        facilityApi.deleteFacility(payload, (resp: any, msg:any) => {
                            toast.success(msg);
                            getfacilitylist();
                        }, (error: any) => {
                            console.log('error =>', error);
                            toast.error(error);
                        });
                    }
                });

                break;
            case "duplicate":
                // Implement view action
                console.log("duplicate action for row: ", rowData);
                break;
            case "qr":
                // Implement qr action
                console.log("qr action for row: ", rowData); 
                const payload = { qrFacilityList: [{ facilityID: rowData.facilityID, qty: 1 }], facilityNameInQR: true };
                facilityApi.ExportQrCode(payload, (resp: any) => { downloadPDF(resp, 'FacilityQR') },
                    (error: any) => { 
                        toast.error(error);
                    }
                );
                break;
            case "add-sub":
                // Implement add sub action
                console.log("Add sub action for row: ", rowData);
                setSubFacilityFor(rowData.facilityID);
                createSubFacilityModalRef.current.showModal();
                break;
            default:
                console.log("Unknown action: ", action);
        }
        e.target.selectedIndex = -1;
    };

    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
        }
    };


    const onBulkExportPdf = () => {
        const selectedData = getSelectedRows();
        console.log("Selected Data for Deletion:", selectedData);
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            const facilityIDs = selectedData.map((asset: any) => asset.facilityID).join(',');
            const payload = { facilityIDs: facilityIDs };
            facilityApi.Exportpdf(
                payload,
                (resp: any) => {
                    downloadPDF(resp, 'FacilityPdf')
                },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }
    };

    const onBulkExportCsv = async () => {
        const selectedData = getSelectedRows();
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            const facilityIDs = selectedData.map((asset: any) => asset.facilityID).join(',');
            const payload = { facilityIDs: facilityIDs };
            facilityApi.Exportcsv(
                payload,
                (resp: any) => {downloadExcel(resp, 'FacilityXls')},
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }
    };

    const onBulkPrintQR = () => {
        const selectedData = getSelectedRows();
        console.log("Selected Data for Deletion:", selectedData);
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            let qrList: any = [];
            selectedData.map((row: any) => qrList.push({ facilityID: row.facilityID, qty: 1 }));
            const payload = { qrFacilityList: qrList, facilityNameInQR: true };
            facilityApi.ExportQrCode(payload, (resp: any) => { downloadPDF(resp, 'FacilityQR') },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }
    };
    const getfacilitylist = () => {
        const payload:any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
        };

        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }
        setrowData(null);
        facilityApi.getFacilityList(payload, (resp: any) => {
            setrowData(resp.facilityList?resp.facilityList:[]);
            setTotalRecords(resp.totalRecord);
        }, (error: any) => {
            console.log('error =>', error);
            toast.error(error);
        });
    };


    useEffect(() => {
        getProcessingFacilityList()
        getfacilitylist();
    }, [])

    useEffect(() => {
        if (gridApi?.current) {
            // Auto size all columns based on their content
            gridApi?.current.sizeColumnsToFit();
        }
    }, [gridApi]);

    useEffect(() => {
        if (rowData) {
            getfacilitylist();
        }
    }, [currentPage, searchParam, filters]);

     const opensubfacility = (facilityID:any)=>{
        setSubFacilityFor(facilityID);
        createSubFacilityModalRef.current.showModal();
     }

     const createFacilityRef:any = useRef();

    return (
        <Layout>
            <Header title='Facilities'>
                <Header.Right>
                    <Drawer _ref={createDrawerRef} onClose={() => {
                        console.log('close drawer', createFacilityRef?.current?.reset);
                        createFacilityRef?.current?.reset()
                        setEditData(null)
                        }} outsideClose={false}>
                        <Drawer.Button>
                            <Button>Add New Facility</Button>
                        </Drawer.Button>
                        <Drawer.Content title={editData ? 'Edit Facility' : 'Create New Facility'} className='!w-[39.563rem]'>
                            <CreateFacilities _ref={createFacilityRef} editID={editData?.facilityID} onCreate={() => {
                                setEditData(null);
                                getfacilitylist();
                                createDrawerRef?.current?.close();
                            }} onCancel={() => {
                                getfacilitylist();
                                setEditData(null);
                                createDrawerRef?.current?.close()
                            }} />
                        </Drawer.Content>
                    </Drawer>
                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary'>Bulk Actions</Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Facility' className='!w-[39.563rem]'>
                            <Menu onClick={onBulkExportCsv}>Export excel / csv </Menu>
                            <Menu onClick={onBulkExportPdf}>Export pdf</Menu>
                            <Menu onClick={onBulkPrintQR}>Print QR Code</Menu>
                        </Dropdown.Content>
                    </Dropdown>
                </Header.Right>
            </Header>
            <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                <Pagination
                    perPage={PAGE_SIZE}
                    totalRecords={totalRecords}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                />
                <Search onSearch={setSearchParam} />
            </div>
            <div className='bg-[#FAFAFA] w-full'>
                <div className='flex gap-4 px-5 py-2 items-center'>
                    <Button theme='light' onClick={() => filtersRef.current.showModal()}>Filter <Icon name='filter' size={1.40} /></Button>
                    <p className='text-primary font-semibold text-sm cursor-pointer' onClick={()=>{setFilters({})}} >Clear Filters</p>
                </div>
                <div className="ag-theme-alpine px-4 w-full h-1/2">
                    <Drawer _ref={subFacilitiesDrawerRef} onClose={() => setSubFacilities(null)}>
                        <Drawer.Button>
                            {null}
                        </Drawer.Button>
                        <Drawer.Content title={subFacilities?.facilityName} className='!w-[39.563rem]'>
                            <SubFacilities data={subFacilities} onCancel={()=>{subFacilitiesDrawerRef?.current?.close(); setSubFacilities(null)}}  onCreatesub={()=>{opensubfacility(subFacilities?.facilityID) }} />
                        </Drawer.Content>
                    </Drawer>
                    <AgGridReact
                        columnDefs={columnDefs} // Pass columnDefs
                        rowData={rowData} // Pass rowData
                        rowSelection="multiple"
                        onGridReady={onGridReady}
                        pagination={false}
                        domLayout="autoHeight"
                        onRowClicked={onRowClicked}
                        loadingOverlayComponent={Loader}

                    />
                </div>
            </div>
            <CreateSubFacilitiesModal _ref={createSubFacilityModalRef} facilityId={subFacilityFor} />
            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />
        </Layout>
    );
};

export default Facilities;